/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-console */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { toastError } from '../../../redux/actions/alertActions';
import userActions from '../../../redux/actions/userActions';
import config from '../../../config';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: '100%',
    marginTop: '15px',
  },
  input: {
    color: 'white',
  },
  rootField: {
    background: 'white',
  },
}));

const LogInForm = (props) => {
  const { changeTab, login } = props;
  const [email, setemail] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [password, setpassword] = useState('');
  const classes = useStyles();

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = () => {
    if (email && password && typeof login !== 'undefined') {
      setLoading(true);
      try {
        login(email, password, false)
          .then(() => {
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
            toastError('Error while logging in, please try again.');
          });
      } catch {
        setLoading(false);
      }
    } else {
      setLoading(false);
      toastError('Please provide an email and a password');
    }
  };

  return (
    <div style={{
      display: 'flex', height: '65%', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'space-around',
    }}
    >
      <Grid container style={{ width: '100%' }}>
        <Grid xs="12">
          <FormControl className={classes.textField} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              <FormattedMessage id="Login.email" defaultMessage="Email" />
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type="text"
              value={email}
              className={classes.rootField}
              onChange={(e) => setemail(e.target.value)}
              labelWidth={120}
              InputProps={{
                className: classes.input,
              }}
            />
          </FormControl>
        </Grid>
        <Grid xs="12">
          <FormControl className={classes.textField} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              <FormattedMessage id="Login.Password" defaultMessage="Password" />
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setpassword(e.target.value)}
              className={classes.rootField}
              endAdornment={(
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )}
              labelWidth={170}
              InputProps={{
                className: classes.input,
              }}
            />
          </FormControl>
        </Grid>
        <Grid xs="12">
          <Button color="primary" disabled={loading} onClick={() => handleSubmit()} variant="contained" style={{ width: '60%', marginLeft: '20%', marginTop: '20px' }}>
            <FormattedMessage id="Common.signin" defaultMessage={loading ? 'Loading..' : `sign in${config.PLATFORM === 'preprod' ? ' preprod' : ''}`} />
          </Button>
        </Grid>
      </Grid>
      {/* <Grid container>
        <Grid item style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <div
            style={{
              cursor: 'pointer', color: '#1D3A74', marginTop: '10px',
            }}
            onClick={() => changeTab(2)}
          >
            Forgot your password ?
          </div>
        </Grid>
      </Grid> */}
    </div>
  );
};

LogInForm.propTypes = {
  changeTab: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
};

function mapState(state) {
  const {
    loggingIn,
    codeLoggingIn,
    requestNewPassword,
    newPassword,
  } = state.authentication;
  return {
    loggingIn,
    codeLoggingIn,
    requestNewPassword,
    newPassword,
  };
}

const actionCreators = {
  login: userActions.login,
  forgotPassword: userActions.forgotPassword,
  logout: userActions.logout,
};

const connectedLogin = connect(mapState, actionCreators)(LogInForm);

export default reduxForm({
  form: 'log_in_form',
})(connectedLogin);
